module.exports = __webpack_public_path__ + "static/media/slide5-final-transparent.44970f17.png";